import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		transform: "rotate(-45 12 12)",
		children: /* @__PURE__ */ _jsx("g", {
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", { d: "M20 5a1 1 0 00-1-1h-5a1 1 0 000 2h2.57l-3.28 3.29a1 1 0 000 1.42 1 1 0 001.42 0L18 7.42V10a1 1 0 002 0V5zM10.71 13.29a1 1 0 00-1.42 0L6 16.57V14a1 1 0 00-2 0v5a1 1 0 001 1h5a1 1 0 000-2H7.42l3.29-3.29a1 1 0 000-1.42z" })
		})
	})
});
export { SvgExpandVertical as ReactComponent };
